export default __webpack_public_path__ + "static/media/weather.00bf6dd1.png";